/*
 * Title: Rewards/RedeemContent.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Redeem Content page content listing, click on list popup will shows from bottom.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React, { Fragment } from "react";
import Buttonlink from "@components/Button";
import reward_collected from "@assets/reward_collected.gif";
import { Dialog, Transition } from "@headlessui/react";
import Api from "@services/api";
import NotificationService from "@services/notification-service";
import store from "@store/configureStore";
import { NavLink } from "react-router-dom";
import Loader from "@components/Loader";


type Props = {};
type MyState = {
    toggleHeight: boolean;
    isOpen: boolean;
    loader: boolean;
    readyToCollect:boolean;
};
class MagicRedeemContentItem extends React.Component<Props | any, MyState> {
    state: MyState = {
        toggleHeight: false,
        isOpen: false,
        loader: false,
        readyToCollect:false
    };

    toggleHandler = () => {
        this.setState({ toggleHeight: !this.state.toggleHeight });
    };
    openModal = () => {
        //this.props.redeemDrawer(this.props.item);
        this.setState({ isOpen: true });
    };

    closeModal = () => {
        this.setState({ isOpen: false });
    };

    purchaseRadeemPoint = async () => {
        this.setState({ loader: true });
        const json = await Api.purchaseRadeemPoint(
            this.props.item.reward?.id,
            this.props.creatorId
        );
        if (json.status == 200) {
            store.dispatch({
                type: "UPDATE_SCORES_SUCCESS",
                data: json.data,
            });
            this.closeModal();
            this.props?.fetch();
        } else {
            NotificationService.error(json?.data?.error?.message)
        }
        this.setState({ loader: false });
    };

   


    render() {
        let { item, points_redeemed, isUnavailable } = this.props;
        let numPurchases = item.numPurchases;
        item = item.reward;
        let redeemed = false;

        if (numPurchases>0) {
            redeemed = true;
        }

        return (
            <div className="relative">
                <div
                    className={`${this.state.toggleHeight
                        ? "max-h-[100vh] ease-in-out duration-1000"
                        : "lg:max-h-[140px] max-h-[140px]  ease-in-out duration-700"
                        } ${isUnavailable?"bg-btn":"bg-tile"} p-[20px] transition-all rounded-[10px] relative cursor-pointer overflow-hidden`}
                >
                    <div
                        onClick={() => this.toggleHandler()}
                        className="absolute inset-0 z-10"
                    />

                    <div className={` ${!isUnavailable && "bg-body"} opacity-50 bg-white/70  inline-flex justify-center items-center rounded-full`}>
                        <p className={` ${isUnavailable?"text-[#0077C0] ":"tile-inlay-primary opacity-50"}  text-[14px] uppercase font-semibold tracking-wider p-2`}>
                            {isUnavailable?"Unavailable":item.price+" POINTS REQUIRED"}
                        </p>
                    </div>
                    <div className="pt-5">
                        <p className={`text-[18px] leading-6 font-[550] text-white ${this.state.toggleHeight ? null : 'truncate'}`}>
                            {item.title}
                        </p>
                        <p className={`text-[16px] leading-5 font-thin tile-inlay-primary pt-2 opacity-50 ${this.state.toggleHeight ? null : 'truncate'}`}>
                            {item.description}
                        </p>
                    </div>
                    {/* <div className="text-center z-20 relative">
                        {points_redeemed >= (parseInt(item.price) || 0)  ? (
                            <button   onClick={this.openModal} className="mt-6 bg-primary text-center max-w-[300px] w-full mx-auto rounded-full">
                                <div
                                   
                                    className="font-medium text-[18px] leading-[18px] text-primary py-3 px-9"
                                >
                                    redeem
                                </div>
                            </button>
                        ) : (
                            <div className="mt-6 bg-[#434040] rounded-full max-w-[300px] w-full mx-auto">
                                <button className="font-semibold text-[18px] leading-[18px] text-primary opacity-50 py-3 px-6">
                                    earn {(parseInt(item.price) || 0) - points_redeemed} points to unlock
                                </button>
                            </div>
                        )}

                        
                    </div> */}
                </div>
                <Transition
                            appear
                            show={this.state.isOpen}
                            as={Fragment}
                        >
                            <Dialog
                                as="div"
                                className="relative z-50"
                                onClose={this.closeModal}
                            >
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0"
                                    enterTo="opacity-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                >
                                   <div className="fixed inset-0 bg-black bg-opacity-80" />
                                </Transition.Child>

                                <div className={`fixed inset-0`}>
                                    <div className="flex items-end justify-center min-h-full text-center">
                                        <Transition.Child
                                            as={Fragment}
                                            enter="transform transition ease-in-out duration-700"
                                            enterFrom="translate-y-full"
                                            enterTo="translate-y-0"
                                            leave="transform transition ease-in-out duration-700"
                                            leaveFrom="translate-y-0"
                                            leaveTo="translate-y-full"
                                        >
                                            <Dialog.Panel className="w-screen max-w-[685px] transform overflow-hidden rounded-b-none rounded-t-[40px] text-left align-middle shadow-xl transition-all bg-[#1D1D1D]">
                                                <div className="relative">
                                                    <button
                                                        type="button"
                                                        className="text-white rounded-md outline-none hover:text-white hover:opacity-70"
                                                        onClick={
                                                            this.closeModal
                                                        }
                                                    >
                                                        <span className="sr-only">
                                                            Close panel
                                                        </span>
                                                        <div className="w-[25px] h-1 absolute mx-auto top-[10px] left-0 right-0 bottom-0 rounded-full bg-lightBlack"></div>
                                                    </button>
                                                </div>
                                                <div className="px-[30px] text-center">
                                                    <h3 className="tile-inlay-primary font-[550] text-[24px] leading-[31px] mt-[41px]">
                                                        Are you sure you want to
                                                        redeem this reward?
                                                    </h3>
                                                    <p className="mt-[15px] text-[18px] font-normal leading-[22px] tile-inlay-primary opacity-50">
                                                        Please only confirm
                                                        below if you are at the
                                                        prize booth and ready to
                                                        collect your reward in
                                                        person. Once you
                                                        confirm, you will not be
                                                        able to collect another
                                                        reward.
                                                    </p>
                                                    <div className="flex items-center justify-center mt-7 gap-3">
                                                        <label
                                                            htmlFor="redeem"
                                                            className="cursor-pointer flex items-center text-[15px] font-normal"
                                                        >
                                                            <input
                                                                id="redeem"
                                                                type="checkbox"
                                                                className="hidden peer"
                                                                onChange={(e)=>this.setState({readyToCollect:e.target.checked})}
                                                            />
                                                            <span className="peer-checked:bg-[#fff] bg-transparent h-[16px] w-[16px] before:content-[''] relative before:absolute before:bottom-[4.2px] before:left-[1.1px] before:h-[5px] before:w-[10px] before:border-b-2 before:border-l-2 before:-rotate-[45deg] peer-checked:before:border-[#4c4c4c] before:border-transparent inline-block border-2 rounded-[4px]"></span>
                                                        </label>
                                                        <h6 className="tile-inlay-primary text-[16px] leading-[19px] font-semibold">
                                                            I’m ready to collect
                                                            my reward.
                                                        </h6>
                                                    </div>
                                                    <div className="relative mb-4">
                                                       
                                                        <button   
                                                            disabled={!this.state.readyToCollect}
                                                            onClick={this.purchaseRadeemPoint} 
                                                            className={`mt-6 ${!this.state.readyToCollect?"bg-[#434040]":"bg-btn"} text-center max-w-[300px] w-full mx-auto rounded-full`}>
                                                             {this.state.loader?
                                                             <Loader height={30} width={30} white={true} />:
                                                            <div
                                                            
                                                                className={`font-medium text-[18px] leading-[18px] btn-inlay-primary py-3 px-9`}
                                                            >redeem now</div>
                                                            }
                                                        </button>
                                                    </div>
                                                </div>
                                            </Dialog.Panel>
                                        </Transition.Child>
                                    </div>
                                </div>
                            </Dialog>
                        </Transition>
            </div>
        );
    }
}

export default MagicRedeemContentItem;
